import { all, fork } from "redux-saga/effects";
import libraryCardSaga from "./libraryCardSaga";

// Root saga that combines all sagas
export default function* rootSaga() {
  yield all([
    fork(libraryCardSaga),
    // Add other sagas here as needed
  ]);
}
